module.exports = __webpack_public_path__ + "img/tortoise.6aed1069.png";